import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  lng: 'en', // cimode
  interpolation: {
    escapeValue: false, // react already safe from xss
  },
  fallbackLng: 'en',
  defaultNS: 'common',
  fallbackNS: 'common',
  react: { useSuspense: true },
});

export { i18n };
